module.exports = __webpack_public_path__ + "img/clam.eb8e4a56.svg";